import { getAdditional } from "./Additional";
import { SKU } from "./getUploadResult";

export function ReadFileExcel(e: File, callback: (e: any[]) => void) {
  const extension = e.name.split(".")[e.name.split(".").length - 1];

  if (extension === "xlsx") {
    const read = new FileReader();
    const items: any[] = [];
    read.onload = () => {
      import("xlsx").then((xlsx) => {
        const workbook = xlsx.read(read.result, {
          type: "binary",
        });

        workbook.SheetNames.forEach((sheet) => {
          const rows = xlsx.utils.sheet_to_json(workbook.Sheets[sheet]);
          rows.map((x: any) => {
            const additional = getAdditional(x).map(function (a, i) {
              if (a === undefined) return "";
              else {
                if (i < 10) {
                  return a;
                }
              }
              return "";
            });
            const color: string = x["Attribute1 (Colors)"];
            const size: string = x["Attribute2 (Sizes)"];
            const dimension: string = x["Dimension"];

            if (dimension.split("\n").length > 1) {
              return "";
            }

            if (color.split("\n").length > 1) {
              return "";
            }

            if (size.split("\n").length > 1) {
              return "";
            }

            const sku_barcode = SKU(
              undefined,
              color === undefined || color === "" ? [" "] : color.toLowerCase().split(","),
              size === undefined || size === "" ? [""] : size.toLowerCase().split(","),
            );
            items.push({
              title: JSON.stringify({ en: x.Title, km: x["Title Khmer"], zh: x["Title Chinese"] }),
              description: JSON.stringify({
                en: x.Description,
                km: x["Description Khmer"],
                zh: x["Description Chinese"],
              }),
              brand_id: x["Brand ID"],
              category_id: x["Category ID"],
              colours: color ? color.split(",").join(",") : " ",
              size: size ? size.split(",").join(",") : " ",
              picture: x["Main Image Address"].split("||")[0],
              color_binding: x["Main Image Address"].split("||")[1],
              consumable: (x["Consumable"] as string).toLocaleLowerCase() === "yes" ? "T" : "F",
              dimension_width: x["Dimension"].split(",")[0],
              dimension_height: x["Dimension"].split(",")[1],
              dimension_length: x["Dimension"].split(",")[2],
              images: additional.filter((a) => a !== ""),
              need_freezer: "F",
              remote_stock: (x["Remote Stock"] as string).toLocaleLowerCase() === "yes" ? "T" : "F",
              remote_stock_duration_to: "20",
              remote_stock_duration_from: "10",
              returnable: "F",
              saleprice: x["Offer Price (USD)"],
              sku_barcode,
              supplier_code: x[`Supplier's Product Code`] + "",
              video: "",
              weight: x["Weight"] + "",
            });
            return items;
          });
          callback(items);
        });
      });
    };
    read.readAsBinaryString(e);
  }
}
